import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {Giong} from '@entities/giong/giong.model';
import {GiongService} from '@entities/giong/giong.service';
import {JhiEventManager} from 'ng-jhipster';
import {DATE_FORMAT} from '@shared/constants/input.constants';
import {Title} from '@angular/platform-browser';
import {DonViService} from '@entities/don-vi';
import {Principal} from '@app/core';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-giong-dialog',
  templateUrl: './giong-dialog.component.html',
})
export class GiongDialogComponent implements OnInit {
  giong: Giong;
  isSaving: boolean;
  dateFormat: string = DATE_FORMAT;
  listUnit$: any;
  customerData: any;
  customerId = null;
  private unsubscribeAll = new Subject();
  constructor(
    private dialogRef: MatDialogRef<GiongDialogComponent>,
    private giongService: GiongService,
    private eventManager: JhiEventManager,
    private titleService: Title,
    private principal: Principal,
    private translate: TranslateService,
  ) {
    this.isSaving = false;
    this.listUnit$ = [];
    this.customerData = [];
    this.giong = new Giong();
  }

  ngOnInit() {
    this.principal
      .getAuthenticationState()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((user) => {
        if (user) {
          this.customerId = user.customerId;
          if (user.customerId) {
            this.giong.tbCustomerId =
              this.giong.tbCustomerId || user.customerId;
          }
        }
      });
    if (this.giong.id !== null) {
      this.titleService.setTitle(
        this.translate.instant('entities.giong.giong.edit'),
      );
    } else {
      this.titleService.setTitle(
        this.translate.instant('entities.giong.giong.add'),
      );
    }
  }

  save() {
    this.isSaving = true;
    this.giong.tbSuppliesTypeId = 1;
    if (this.giong.id !== null) {
      this.giongService.update(this.giong).subscribe(
        (response) => {
          this.onSaveSuccess(response);
        },
        () => this.onSaveError(),
      );
    } else {
      this.giongService.create(this.giong).subscribe(
        (response) => {
          this.onSaveSuccess(response);
        },
        () => this.onSaveError(),
      );
    }
  }

  private onSaveSuccess(result) {
    this.isSaving = false;
    this.eventManager.broadcast({
      name: 'giongListModification',
      content: 'Giong',
    });
    this.dialogRef.close(true);
  }

  private onSaveError() {
    this.isSaving = false;
  }
}

@Component({
  selector: 'app-giong-popup',
  template: '',
})
export class GiongPopupComponent implements OnInit, OnDestroy {
  private dialogRef: MatDialogRef<GiongDialogComponent>;
  dateFormat: string = DATE_FORMAT;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private titleService: Title,
    private giongService: GiongService,
    private donViService: DonViService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.activatedRoute.data.subscribe(({giong}: Data) => {
      setTimeout(() => {
        this.dialogRef = this.dialog.open(GiongDialogComponent, {
          disableClose: true,
          width: '380px',
        });
        if (giong !== undefined) {
          this.dialogRef.componentInstance.giong = giong.tbSuppliesDTO;
        }
        this.giongService.listUnit().subscribe((res: any) => {
          this.dialogRef.componentInstance.listUnit$ = res;
        });

        this.donViService.dropdown().subscribe((data: any) => {
          this.dialogRef.componentInstance.customerData = data.body;
        });

        this.dialogRef.afterClosed().subscribe(
          (result) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
          (reason) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
        );
      }, 0);
    });
  }

  ngOnDestroy() {
    this.titleService.setTitle(
      this.translate.instant('entities.giong.giong.list'),
    );
    this.dialogRef = null;
  }
}
